var render, staticRenderFns
import script from "./BaseLayoutResultGeneric.vue?vue&type=script&lang=js"
export * from "./BaseLayoutResultGeneric.vue?vue&type=script&lang=js"
import style0 from "./BaseLayoutResultGeneric.vue?vue&type=style&index=0&id=d27d5aae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27d5aae",
  null
  
)

export default component.exports